import { Component, OnInit } from '@angular/core';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExam } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-upload-marksheet',
  templateUrl: './upload-marksheet.component.html',
  styleUrls: ['./upload-marksheet.component.scss']
})
export class UploadMarksheetComponent implements OnInit {
  exam: IExam = examDefault;

  file: File = null;
  modelError: string;
  constructor(private popoverRef: PopoverRef<UploadMarksheetComponent>,
    private examsevice: ExamService, private snackBar: SnackbarService,) { }

  ngOnInit() {
    if (this.examsevice.selectedExams.length === 1) {
      this.exam = this.examsevice.selectedExams[0];
    }
  }

  close() {
    this.popoverRef.close();
  }
  onFileChange(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.file = event.target.files[0];
    }
  }
  async uploadMarkSheet() {
    this.modelError = '';
    try {
      this.validateModel();
      if (this.modelError !== '') {
        return
      }
      let formData = new FormData();
      formData.append('examinationID', '' + this.exam.id);
      formData.append('files', this.file);

      await this.examsevice.uploadMarkSheet(formData).then(s => {
        this.snackBar.success('Upload Successfull');
        this.close();
      });
    } catch (error) {
      console.log(error);
      
      this.snackBar.error('Error Uploading: '+error);
    }

  }
  validateModel() {
    if (!this.file) {
      this.modelError += "\n*No file selected\n"
    }
  }
}
